var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAttach = function SvgAttach(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 11,
    "data-width-20": 14,
    "data-width-24": 17,
    viewBox: "0 0 16.4 18.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.107 18.493a6 6 0 0 1-4.27-10.32l6.94-6.93a4.243 4.243 0 0 1 6 6l-6.87 6.87a2.54 2.54 0 0 1-3.52 0 2.49 2.49 0 0 1 0-3.52l6.83-6.89a.74.74 0 0 1 1.06 0 .75.75 0 0 1 0 1.06l-6.84 6.87a1 1 0 0 0-.29.7 1 1 0 0 0 .29.7 1 1 0 0 0 1.4 0l6.87-6.87a2.68 2.68 0 0 0 .8-1.92 2.72 2.72 0 0 0-.8-1.94 2.81 2.81 0 0 0-3.87 0l-6.94 6.94a4.543 4.543 0 0 0 6.42 6.43l5.77-5.77a.75.75 0 0 1 1.06 0 .74.74 0 0 1 0 1.06l-5.77 5.77a6 6 0 0 1-4.27 1.76"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAttach);
export default ForwardRef;